// extracted by mini-css-extract-plugin
module.exports = {"bottomTextTitle":"_1mpy6","subTitle":"_32IvU","bottomTextSection":"_728tk"};